import React, { Component } from "react";
import { connect } from "react-redux";
import { AvForm, AvField } from "availity-reactstrap-validation";

import {
	Row,
	Col,
	Modal,
	ModalHeader,
	ModalBody,
	ModalFooter,
	Button,
	FormGroup,
	Label,
} from "reactstrap";
import Select from "react-select";
import { getMiniLocations } from "../../../store/Mini/actions";
import { getMiniSubLocations } from "../../../store/Mini/actions";
import {
	getORDERLocations,
	model_open,
	model_close,
	InputChangeValue,
	SelecteChangeValue,
	ORDERlocationAdd,
	LocationImage,
	getOrderLocationRowData,
	clearOrderLocationData,
} from "../../../store/Masters/OrderLocations/action";
import swal from "sweetalert";
import DefaultImg from "../../../assets/images/product/Default_img.jpg";
import { CustomInput } from "reactstrap";

class AddOrderLocations extends Component {
	constructor(props) {
		super(props);
		this.state = {
			leftSideBarType: "icon",
			// bymodel: false,
			imagePreviewUrl: null,
			bymodel: false,
		};
		this.ChangeHandeler = this.ChangeHandeler.bind(this);
		this.handleValidSubmit = this.handleValidSubmit.bind(this);
	}

	componentDidMount() {
		this.props.getORDERLocations({
			...this.props.params,
			page: 1,
			search: "",
		});
		

		this.setState({
			bymodel: this.props.CPmodel ? true : false,
		});

		// always load locations list
		this.props.getMiniLocations();

		// get id from props
		let id;
		if (this.props.CPmodel) {
			id = this.props.openId; // if opened in modal
		} else {
			id = this.props.match?.params?.id; // from route
		}

		if (id && id !== "0") {
			// edit mode
			this.setState({ id: parseInt(id, 10) });
			this.props.getOrderLocationRowData(id, this.props.history);
		} else {
			// add mode
			this.setState({ id: 0 });
			this.props.clearOrderLocationData();
		}
	}

	  componentDidUpdate(prevProps) {
   
    const rawImg = this.props.rowdata?.image;

    // RUN ONLY IF:
    // 1. rowdata.image exists
    // 2. fileType is not already decided
    if (
      !this.state.fileType &&
      typeof rawImg === "string" &&
      rawImg.trim() !== ""
    ) {
      const imageUrl = rawImg.trim().toLowerCase();

      if (imageUrl.endsWith(".pdf")) {
        this.setState({
          fileType: "pdf",
          fileName: rawImg.split("/").pop(),
          imagePreviewUrl: null,
        });
      } else {
        this.setState({
          fileType: "image",
          imagePreviewUrl: rawImg,
        });
      }
    }
  }
	ChangeHandeler(e) {
		this.props.InputChangeValue({
			key: e.target.name,
			value: e.target.value,
		});
	}

	handleFileChange(e) {
		e.preventDefault();
		const file = e.target.files[0];

		if (!file) {
			this.props.LocationImage({});
			this.setState({ imagePreviewUrl: null, fileType: null });
			return;
		}

		const fileType = file.type;

		// ✅ Save file in redux
		this.props.LocationImage(file);

		// ✅ Handle preview logic
		if (fileType.startsWith("image/")) {
			const reader = new FileReader();
			reader.onloadend = () => {
				this.setState({
					imagePreviewUrl: reader.result,
					fileType: "image",
				});
			};
			reader.readAsDataURL(file);
		} else if (fileType === "application/pdf") {
			// for PDFs, just show a PDF icon or text
			this.setState({
				imagePreviewUrl: null,
				fileType: "pdf",
				fileName: file.name,
			});
		} else {
			swal("Only images or PDF files are allowed!", { icon: "error" });
			this.setState({ imagePreviewUrl: null, fileType: null });
		}
	}

	handleValidSubmit() {
		var data = this.props.rowdata;

		if (!data.location_id) {
			swal("Please select a Location!", { icon: "error" });
			return;
		}
		if (!data.sublocation_id) {
			swal("Please select a Sub Location!", { icon: "error" });
			return;
		}
		if (!data.name) {
			swal("Please enter a Location Name!", { icon: "error" });
			return;
		}

		this.props.ORDERlocationAdd({
			data,
			image: this.props.image, // rename later if you prefer
			fileType: this.state.fileType, // 'image' or 'pdf'
			LoId: data.id ? data.id : 0,
			history: this.props.history,
			model: this.state.bymodel ? true : false,
		});

		// swal(
		// 	data.id
		// 		? "Order Location updated successfully!"
		// 		: "Order Location added successfully!",
		// 	{ icon: "success" }
		// );
	}

	render() {
		var data = this.props.rowdata;

		let $filePreview = null;

		if (this.state.fileType === "image" && this.state.imagePreviewUrl) {
			$filePreview = (
				<img
					className="order-img"
					alt="Preview"
					src={this.state.imagePreviewUrl}
					style={{
						height: "250px",
						width: "350px",
						cursor: "pointer",
					}}
				/>
			);
		} else if (this.state.fileType === "pdf") {
			$filePreview = (
				<div
					className="img-thumbnail text-center"
					style={{
						height: "250px",
						width: "350px",
						display: "flex",
						flexDirection: "column",
						justifyContent: "center",
						alignItems: "center",
					}}>
					<i className="ri-file-pdf-line ri-5x text-danger"></i>
					<span className="font-size-14 mt-2">
						{this.state.fileName}
					</span>
				</div>
			);
		} else if (
      typeof this.props.rowdata?.image === "string" &&
      !this.state.fileType &&
      !this.props.rowdata?.image.trim().toLowerCase().endsWith(".pdf")
    ) {
      // Only render image if NOT a PDF
      $filePreview = (
        <img
          className="product-img"
          alt="User"
          src={this.props.rowdata.image}
          style={{
            height: "250px",
            width: "350px",
            cursor: "pointer",
          }}
        />
      );
    } else {
			$filePreview = (
				<div
					className="img-thumbnail text-center"
					style={{
						height: "250px",
						width: "350px",
						display: "flex",
						flexDirection: "column",
						justifyContent: "center",
						alignItems: "center",
					}}>
					<i className="ri-upload-cloud-line ri-8x"></i>
					<span className="font-size-16">
						Select Order Location File (Image or PDF)
					</span>
				</div>
			);
		}
		return (
			<React.Fragment>
				<Modal isOpen={true} backdrop="static" centered size="lg">
					<ModalHeader toggle={() => this.props.history.goBack()}>
						{this.state.id && this.state.id !== 0
							? "EDIT ORDER LOCATION"
							: "ADD ORDER LOCATION"}
					</ModalHeader>

					<AvForm
						className="form-horizontal"
						onValidSubmit={this.handleValidSubmit}>
						<ModalBody>
							<Row className="justify-content-center">
								<Col md={10}>
									<Row className="justify-content-center">
										<Col md={9}>
											<FormGroup row>
												<Col md={4}>
													<Label
														htmlFor="Location_id_select"
														className="col-form-label float-right">
														Select Location
													</Label>
												</Col>
												<Col md={8}>
													<Select
														id="Location_id_select"
														name="Location_id_select"
														classNamePrefix="select2-selection"
														isClearable={
															this.props.rowdata
																?.locationsLabel
																? true
																: false
														}
														options={this.props.locationslist.map(
															(item, index) => ({
																label: item.name,
																value: item.id,
															})
														)}
														value={{
															label:
																data.locationsLabel ==
																null
																	? "select Location"
																	: data.locationsLabel,
															value: data.location_id,
														}}
														onChange={(e) => {
															this.props.getMiniSubLocations(
																e.value
															);
															this.props.SelecteChangeValue(
																{
																	key: "locationsLabel",
																	label: e?.label,
																	key2: "location_id",
																	value: e?.value,
																}
															);
														}}
													/>
												</Col>
											</FormGroup>

											<FormGroup row>
												<Col md={4}>
													<Label
														htmlFor="Location_id_select"
														className="col-form-label float-right">
														Sub Location
													</Label>
												</Col>
												<Col md={8}>
													<Select
														id="sublocation_id_select"
														name="sublocation_id_select"
														classNamePrefix="select2-selection"
														isDisabled={
															!this.props.rowdata
																.location_id
														}
														options={this.props.sublocationslist?.map(
															(item, index) => ({
																label: item.name,
																value: item.id,
															})
														)}
														value={
															data.sublocation_id
																? {
																		label: data.sublocationLabel,
																		value: data.sublocation_id,
																  }
																: null
														}
														onChange={(e) => {
															this.props.SelecteChangeValue(
																{
																	key: "sublocationLabel",
																	label: e?.label,
																	key2: "sublocation_id",
																	value: e?.value,
																}
															);
														}}
													/>
												</Col>
											</FormGroup>

											<FormGroup row>
												<Col md={4}>
													<Label
														htmlFor="LocationName"
														className="col-form-label float-right">
														Order Location Name
													</Label>
												</Col>
												<Col md={8}>
													<AvField
														name="name"
														type="text"
														value={data.name}
														onChange={
															this.ChangeHandeler
														}
														className="form-control"
														id="LocationName"
														placeholder="Enter Location Name"
														errormessage=" Please provide a valid Location Name"
														validate={{
															required: {
																value: true,
															},
														}}
													/>
												</Col>
											</FormGroup>

											<FormGroup row>
												<Col md={4}>
													<Label
														htmlFor="remarks"
														className="col-form-label float-right">
														Remarks
													</Label>
												</Col>
												<Col md={8}>
													<AvField
														name="remarks"
														type="text"
														value={data.remarks}
														onChange={
															this.ChangeHandeler
														}
														className="form-control"
														id="remarks"
														placeholder="Enter remarks"
													/>
												</Col>
											</FormGroup>

											<FormGroup>
												<AvField
													className="form-control"
													type="hidden"
													value={data.id}
													id="id"
													name="id"
												/>
											</FormGroup>
										</Col>

										<Col md={6}>
											<Row>
												<Col md={12} className="mb-0">
													<FormGroup className="mb-0">
														<div>
															<Label
																htmlFor="customFile"
																className="col-form-label">
																OrderLocations
																Image
															</Label>
														</div>

														<div className="product-detail">
															<div className="mt-2 align-items-center ">
																<label htmlFor="productCustomFile">
																	{
																		$filePreview
																	}
																</label>

																<span className="text-danger mt-0">
																	{
																		this
																			.props
																			.error_msg
																			?.image
																	}
																</span>
																<div
																	style={{
																		width: "300px",
																	}}>
																	<CustomInput
																		type="file"
																		className="file-upload"
																		id="productCustomFile"
																		accept="image/*,application/pdf" // ✅ allow image or pdf
																		multiple={
																			false
																		}
																		onChange={(
																			e
																		) =>
																			this.handleFileChange(
																				e
																			)
																		}
																		validate={{
																			required:
																				{
																					value: true,
																				},
																		}} // ✅ rename for clarity
																	/>
																</div>
															</div>
														</div>
													</FormGroup>
												</Col>
											</Row>
										</Col>
									</Row>
								</Col>
							</Row>

							<ModalFooter>
								<Button
									type="button"
									className="btn btn-danger"
									color="light"
									onClick={() => this.props.history.goBack()}>
									Close
								</Button>
								<Button
									type="submit"
									className="btn btn-primary"
									color="primary">
									Save
								</Button>
							</ModalFooter>
						</ModalBody>
					</AvForm>
				</Modal>
			</React.Fragment>
		);
	}
}

const mapStatetoProps = (state) => {
	const { locationslist, sublocationslist } = state.Mini;
	const { model, rowdata, image } = state.orderLocations;
	return {
		locationslist,
		model,
		rowdata,
		sublocationslist,
		image,
	};
};

export default connect(mapStatetoProps, {
	getMiniLocations,
	getMiniSubLocations,
	getORDERLocations,
	InputChangeValue,
	SelecteChangeValue,
	ORDERlocationAdd,
	model_open,
	model_close,
	LocationImage,
	getOrderLocationRowData,
	clearOrderLocationData,
})(AddOrderLocations);
